<div class="row">
  <div class="col-12">
    <hpm-search-bar (searchValue)="addSearchFilter($event)"
                    placeholder="TEMPLATE_OVERVIEW.SEARCH_PLACEHOLDER"
                    [autocompleteOptions]="autocompleteOptions"></hpm-search-bar>
  </div>
  <div class="table col-12">

    <cx-table-container [tableLoading]="tableLoading">
      <cx-table-with-pagination
        [initialTableColumnsOrder]="tableColumnsOrder"
        [data]="shownData"
        [sorting]="tableSettings.sort"
        (sortChange)="onSortingDirectionChanged($event)"
        [minLengthForPaginator]="10"
        [paginatorPageSize]="tableSettings.pageSize"
        [paginatorPageIndex]="tableSettings.pageNumber"
        [paginatorTotalRecordsCount]="totalElementCount"
        (paginatorChange)="onPaginatorChange($event)"
        matSort>

        <ng-container matColumnDef="{{templateColumnDef.NAME}}">

          <mat-header-cell class="name-header" *matHeaderCellDef mat-sort-header>
            {{ 'TEMPLATE_OVERVIEW.TABLE.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div>{{ row.name }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="{{templateColumnDef.ACTIONS}}">
          <mat-header-cell class="action-header" *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index">
            <button [disabled]="row.type === templateType.CERTIFICATE"
                    class="cx-icon-stroked-button"
                    mat-stroked-button
                    (click)="openEditor(i)">
              <mat-icon class="material-symbols-outlined">edit</mat-icon>
            </button>

            <button class="cx-icon-stroked-button" mat-stroked-button [disabled]="!isPrivilegedUser()"
                    (click)="copyTemplate(row.id)">
              <mat-icon class="material-symbols-outlined">file_copy</mat-icon>
            </button>
            <button class="cx-icon-stroked-button" mat-stroked-button [disabled]="!isPrivilegedUser()"
                    hpmSecureDownload [url]="getDownloadUrl(row.id)" [fileName]="row.name">
              <mat-icon class="material-symbols-outlined">download</mat-icon>
            </button>
            <hpm-template-upload-dialog [disabled]="!isPrivilegedUser()"
                                        [template]="row"
                                        (templateChanged)="loadTemplateData()"
            ></hpm-template-upload-dialog>


            <button class="cx-icon-stroked-button" mat-stroked-button
                    [disabled]="!isUserAdmin()"
                    [hpmConfirmDelete]="row.name" (confirmation)="deleteTemplate($event, row.id)">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

      </cx-table-with-pagination>

      <div>
        <ng-container
          cxTableLabel="{{'TEMPLATE_OVERVIEW.TABLE.TABLE_LABEL_ROWS_PER_PAGE' | translate}}"
          [type]="tableLabelType.PAGINATOR_ITEMS_PER_PAGE_LABEL"
        />
        <ng-container
          cxTableLabel="{start} - {end } / { totalRecords } {{'TEMPLATE_OVERVIEW.TABLE.TABLE_LABEL_ROW' | translate}}"
          [type]="tableLabelType.PAGINATOR_ITEMS_OUT_OF_ALL_LABEL"/>
      </div>


      <cx-table-loading-indicator
        loadingIndicatorText="{{'TEMPLATE_OVERVIEW.TABLE.LOADING' | translate}}"></cx-table-loading-indicator>
    </cx-table-container>
  </div>
</div>
<cx-floating-button [text]="'TEMPLATE_OVERVIEW.ADD_NEW_TEMPLATE' | translate"
                    routerLink="/template/new"></cx-floating-button>
